<span *ngIf="account().mutedByUser" class="pt-badge badge-danger" i18n>Muted</span>
<span *ngIf="account().mutedServerByUser" class="pt-badge badge-danger" i18n>Instance muted</span>
<span *ngIf="account().mutedByInstance" class="pt-badge badge-danger" i18n>Muted by your instance</span>
<span *ngIf="account().mutedServerByInstance" class="pt-badge badge-danger" i18n>Instance muted by your instance</span>
